import React, { useState, useEffect } from "react";
import NftAvatar from "./NftAvatar";

const PhoneMockup = ({ t }) => {
  const phone = t.hero.phone;
  const conversation = phone.conversation;
  const [visibleCount, setVisibleCount] = useState(0);

  useEffect(() => {
    if (visibleCount < conversation.length) {
      const timer = setTimeout(() => {
        setVisibleCount((c) => c + 1);
      }, 1200);
      return () => clearTimeout(timer);
    } else {
      // 循環：等待後重置
      const timer = setTimeout(() => {
        setVisibleCount(0);
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [visibleCount, conversation.length]);

  // 語言切換時重置動畫
  useEffect(() => {
    setVisibleCount(0);
  }, [t]);

  return (
    <div className="phone-frame">
      {/* hover 加密盾牌 */}
      <div className="phone-shield">
        <svg className="phone-shield-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
          <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
          <path d="M9 12l2 2 4-4" />
        </svg>
        <span className="phone-shield-text">{phone.status === "已加密" ? "訊息已加密保護" : "Messages Protected"}</span>
      </div>
      <div className="phone-notch" />
      <div className="phone-topbar">
        <span className="phone-back">
          <svg width="8" height="14" viewBox="0 0 8 14" fill="none" stroke="#00d46a" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M7 1L1 7l6 6"/>
          </svg>
        </span>
        <div className="phone-contact">
          <NftAvatar id={0} size={36} />
          <div className="phone-contact-info">
            <span className="phone-name">{phone.contact}</span>
            <span className="phone-status">
              <span className="phone-status-dot" />
              {phone.status}
            </span>
          </div>
        </div>
        <span className="phone-call">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#00d46a" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/>
          </svg>
        </span>
      </div>

      <div className="phone-messages">
        {/* 輸入中指示器 */}
        {visibleCount < conversation.length && visibleCount > 0 && (
          <div className="phone-msg phone-msg-them phone-typing-row">
            <div className="phone-typing">
              <span /><span /><span />
            </div>
          </div>
        )}

        {conversation.slice(0, visibleCount).map((msg, i) => (
          <div
            className={`phone-msg ${msg.from === "me" ? "phone-msg-me" : "phone-msg-them"} phone-msg-animate`}
            key={`${visibleCount}-${i}`}
          >
            <div className="phone-msg-bubble">{msg.text}</div>
          </div>
        ))}
      </div>

      <div className="phone-inputbar">
        <div className="phone-input-plus">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#999" strokeWidth="2" strokeLinecap="round">
            <line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>
          </svg>
        </div>
        <div className="phone-input-field">Message...</div>
        <div className="phone-input-send">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="#00d46a">
            <path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"/>
          </svg>
        </div>
      </div>
      <div className="phone-home-bar" />
    </div>
  );
};

export default PhoneMockup;
